import { api } from "../services/index";

// Logout waits for DELETE /session, so a hanging backend must not hold it up.
const SESSION_REQUEST_TIMEOUT_MS = 5000;

// The session cookie is a best-effort companion of the Bearer token, so its
// failures must never trigger the global error handling (callout, /forbidden).
const bestEffort = {
  skipGlobalErrorHandling: true,
  timeout: SESSION_REQUEST_TIMEOUT_MS,
};

export function createSession() {
  // undefined, not null: with null axios sends a form Content-Type that Fastify rejects (415)
  return api.post("/session", undefined, bestEffort);
}

export function deleteSession() {
  return api.delete("/session", undefined, bestEffort);
}
